import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-issue-alert-update',
  templateUrl: './issue-alert-update.component.html',
  styleUrls: ['./issue-alert-update.component.css']
})
export class IssueAlertUpdateComponent implements OnInit {
  validate: any;
  IS_Id: any;
  issue: any = {};
  statusList;
  UsersList;
  data: any;
  mode: any;
  Issueresponse;
  issueresList;
  UserName: any;
  interstatusList;
  IS_Ticket_No: any;
  manager: any = null;
  Forwardto: any;
  formSubmitted: boolean;
  mindate: any;
  numericpattern = "[.,0-9]+";
  numericpatternti = "[0-9]+";
  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private errorHandler: ErrorHandler,private datePipe: DatePipe) {
    this.formSubmitted = false;
  }

  ngOnInit() {
    this.GetStatus();
    this.route.params.subscribe(params =>
      this.IS_Id = params['IS_Id']
    );
    this.route.params.subscribe(params =>
      this.IS_Ticket_No = params['IS_Ticket_No']
    );
    this.route.params.subscribe(params =>
      this.mode = params['mode']
    );
    if (this.IS_Id != null || this.IS_Ticket_No != null)
      this.GetIssueForTheId(this.IS_Id);
    this.GetIssueResponse(this.IS_Ticket_No, this.IS_Id);
 
  }

  GetIssueForTheId(IS_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetIssueForTheId(IS_Id)
      .subscribe(
        (data: any) => {
          this.issue = data;
          this.issue.IS_DisplaytoCustomer = 0;
          if (this.issue.IS_Total_Issue == 0 && this.issue.IS_Status==1) {
          this.issue.IS_Total_Issue=1;
          }
          if (this.issue.IS_Exp_Delivery != null) {
            this.issue.IS_Exp_Delivery = ((this.issue.IS_Exp_Delivery).split('T'))[0];
          }
          this.Forwardto = this.issue.IS_To_UserId;
          this.mindate = new Date();

          if (this.issue.IS_UploadPath != null) { this.issue.IS_UploadPath = data.IS_UploadPath; }

          if (this.issue.IS_UploadPath1 != null) { this.issue.IS_UploadPath1 = data.IS_UploadPath1; }

          if (this.issue.IS_UploadPath2 != null) { this.issue.IS_UploadPath2 = data.IS_UploadPath2; }

          if (this.issue.IS_Severity == null) { this.issue.IS_Severity = undefined; this.issue.IS_Category = undefined; this.issue.IS_Internal_Status = undefined }

          this.GetAllUsers(IS_Id)
          this.GetAllInternalStatus(data.IS_Proj_ID_FK)
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  GetIssueViewForTheId(IS_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetIssueViewForTheId(IS_Id)
      .subscribe(
        (data: any) => {
          this.issue = data;
          if (this.issue.IS_Exp_Delivery != null)
            this.issue.IS_Exp_Delivery = ((this.issue.IS_Exp_Delivery).split('T'))[0];
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }


  GetIssueResponse(IS_Ticket_No, IS_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetIssueResponse(IS_Ticket_No, IS_Id)
      .subscribe(
        (data: any) => {
          this.issueresList = data;
          for (let i = 0; i < this.issueresList.length; i++) {
            if (this.issueresList[i].IS_DisplaytoCustomer == 0)
              this.issueresList[i].IS_DisplaytoCustomer = "No"
            else
              this.issueresList[i].IS_DisplaytoCustomer = "Yes"
          }

          for (let i = 0; i < this.issueresList.length; i++) {
            if (this.issueresList[i].Name == 'Project Management Team') {
              if (this.manager == null)
                this.issueresList[i].IR_Est_Hrs = "managerview";
              this.manager = "managerview";
            }
          }

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetStatus() {

    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllStatus()
      .subscribe(
        (data: any) => {
          this.statusList = data;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetAllInternalStatus(Proj_ID) {

    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllInternalStatus(Proj_ID)
      .subscribe(
        (data: any) => {
          this.interstatusList = data;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetAllUsers(IS_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllUsers(IS_Id)
      .subscribe(
        (data: any) => {
          this.UsersList = data;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  onSubmit(form: NgForm, IS_Ticket_No: any) {
debugger;
    // this.mindate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    // this.validate=this.datePipe.transform(form.value.IS_Exp_Delivery,'dd');
    // if (form.value.IS_Exp_Delivery < this.mindate) {
      document.getElementById('loader-spinner').style.display = "block";
      if (!form.invalid) {

        form.value.IR_IS_ID_FK = this.IS_Id;
        if (form.value.IS_DisplaytoCustomer == true) {
          form.value.IS_DisplaytoCustomer = 1;
        }
        else {
          form.value.IS_DisplaytoCustomer = 0;
        }
        if (form.value.IS_To_UserId == this.Forwardto) {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Warning!', 'Forwarding to Same User is not Allowed', 'warning');
        }
        else
          this.data = this.userService.createIssueResponse(form.value);
        this.data.subscribe(
          (response) => {
            document.getElementById('loader-spinner').style.display = "none";
            swal('Success!', 'Ticket No.' + IS_Ticket_No + ' has been Updated successfully.', 'success');
            this.router.navigate(['/home/issue-alert']);
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
      }
      else {
        document.getElementById('loader-spinner').style.display = "none";
        swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
        this.formSubmitted = true;
      }
    // }
    // else{
    //   swal('Warning!', 'Choose current or upcoming date.', 'warning');
    // }
  }

  SaveDetails(IS_Status: any, IR_Note: any, IS_Id: any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.UserName = localStorage.getItem('userName');

    this.data = this.userService.SaveDetails(IS_Status, IR_Note, IS_Id, this.UserName);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('', 'Saved Successfully!', 'success');
        this.router.navigate(['/home/issue-alert']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  SaveuserDetails(IR_Note: any, IS_Id: any, IS_Ticket_No: any) { 
    debugger   
    if (IR_Note != null || IR_Note != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.UserName = localStorage.getItem('userName');

      let udm = 
      {
        iR_Note:IR_Note,
        iS_Id : IS_Id,
        userName : this.UserName
      }

      //this.data = this.userService.SaveuserDetails(IR_Note, IS_Id, this.UserName);
      this.data = this.userService.SaveuserDetails(udm);
      
      this.data.subscribe(
        (response) => {
          // this.GetIssueResponse(IS_Id)
          document.getElementById('loader-spinner').style.display = "none";
          swal('Success!', 'Ticket No.' + IS_Ticket_No + ' has been Updated successfully.', 'success');
          this.router.navigate(['/home/issue-alert']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    }
    else {
      document.getElementById('loader-spinner').style.display = "none";
      swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
      this.formSubmitted = true;
    }
  }

  CloseIssue(IS_Id, IS_Ticket_No, IR_Note, IS_DisplaytoCustomer: any) {
    debugger;
    if (IS_DisplaytoCustomer == true) {
      IS_DisplaytoCustomer = 1;
    }
    else { IS_DisplaytoCustomer = 1; }
    if (IR_Note != null || IR_Note != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.UserName = localStorage.getItem('userName');

      let udm = {
        iS_Id : IS_Id,
        iS_Ticket_No :IS_Ticket_No,
        iR_Note:IR_Note,
        iS_DisplaytoCustomer: IS_DisplaytoCustomer,
        userName:this.UserName
      }

      //this.data = this.userService.CloseIssue(IS_Id, IS_Ticket_No, IR_Note, IS_DisplaytoCustomer, this.UserName);
      this.data = this.userService.CloseIssue(udm);      
      this.data.subscribe(
        (response) => {
          // this.GetIssueResponse(IS_Id)
          document.getElementById('loader-spinner').style.display = "none";
          swal('Success!', 'Ticket No.' + IS_Ticket_No + ' has been Updated successfully.', 'success');
          this.router.navigate(['/home/issue-alert']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    }
    else {
      document.getElementById('loader-spinner').style.display = "none";
      swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
      this.formSubmitted = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/issues/issue-alert-update/issue-alert-update.component.ts